import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build/app/proyectos/[slug]/ProjectDetailClient.tsx");
